var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateYourAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 60,
    viewBox: "0 0 106 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 60,
    rx: 30,
    fill: "#FFEB99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4925 31.0622C65.5144 32.4189 69 34.6389 69 37.7222V48H36V37.7222C36 34.6389 39.4856 32.4189 43.5281 31.0622L44.8069 33.6111L45.2813 34.6389C42.1875 35.5844 39.9188 36.9411 39.9188 37.7222V44.0944H48.6225L50.4375 33.6728L48.4988 29.8083C49.7775 29.6644 51.1181 29.5617 52.5 29.5617C53.8819 29.5617 55.2225 29.6644 56.5012 29.8083L54.5625 33.6728L56.3775 44.0944H65.0812V37.7222C65.0812 36.9411 62.8125 35.5844 59.7187 34.6389L60.1931 33.6111L61.4925 31.0622ZM52.5 15.1111C50.2312 15.1111 48.375 16.9611 48.375 19.2222C48.375 21.4833 50.2312 23.3333 52.5 23.3333C54.7687 23.3333 56.625 21.4833 56.625 19.2222C56.625 16.9611 54.7687 15.1111 52.5 15.1111ZM52.5 27.4444C47.9419 27.4444 44.25 23.765 44.25 19.2222C44.25 14.6794 47.9419 11 52.5 11C57.0581 11 60.75 14.6794 60.75 19.2222C60.75 23.765 57.0581 27.4444 52.5 27.4444Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateYourAccount);
export default __webpack_public_path__ + "static/media/create-your-account.f1b1e8f819ab09061f3095e79fb34a0a.svg";
export { ForwardRef as ReactComponent };